class MultistepForm {
  constructor() {
    this.fieldsInit();
    this.formInit();
  }

  formInit = () => {
    const btn = document.querySelector('.js-multistep-form-btn');
    const modal = document.querySelector('.js-multistep-form');
    const exit = document.querySelector('.js-multistep-form-exit');
    btn?.addEventListener('click', (e) => {
      e.preventDefault();
      modal?.classList.add('active');
    });
    exit?.addEventListener('click', () => {
      modal?.classList.remove('active');
    });
  };

  formDataToUrlEncoded = (formData) => {
    const arr = [];

    for (const [key, value] of formData.entries()) {
      arr.push([key, value]);
    }

    const params = new URLSearchParams();
    arr.forEach(([k, v]) => params.append(k, v));
    return params.toString();
  };

  fieldsInit = () => {
    const tabs = document.querySelectorAll('.js-multistep-tab');
    const navigation = document.querySelectorAll('.js-multiform-nav-item');
    const form = document.querySelector('.js-multistep-form form');

    if (!form) {
      return;
    }

    tabs.forEach((tab, tabIndex) => {
      const tabNumber = parseInt(tab.getAttribute('data-tab'));
      const prev = tab.querySelector('.js-multiform-prev');
      const next = tab.querySelector('.js-multiform-next');
      const requiredInputs = tab.querySelectorAll(
        '.js-multiform-input.required'
      );
      prev?.addEventListener('click', () => {
        tabs.forEach((t, index) => {
          t.classList.remove('active');
          if (index == tabNumber - 1) {
            t.classList.add('active');
          }
        });
      });
      next?.addEventListener('click', () => {
        if (requiredInputs.length > 0) {
          const checker = this.checkInputs(requiredInputs);
          if (checker) {
            tabs.forEach((t, index) => {
              t.classList.remove('active');
              if (index == tabNumber + 1) {
                t.classList.add('active');
              }
            });
            navigation[tabIndex + 1].classList.add('js-quiz-done');
          }
        } else {
          tabs.forEach((t, index) => {
            t.classList.remove('active');
            if (index == tabNumber + 1) {
              t.classList.add('active');
            }
          });
          navigation[tabIndex + 1].classList.add('js-quiz-done');
        }
      });
    });
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const id = form.id;
      const tfaID = form.getAttribute('data-tfa-id');
      const tfaControl = form.getAttribute('data-tfa-control');
      const formData = new FormData(form);
      const tfaFormData = new FormData(form);
      const endpoint = form.action;
      tfaFormData.append('tfa_dbFormId', tfaID);
      tfaFormData.append('tfa_dbControl', tfaControl);
      this.formDataToUrlEncoded(tfaFormData);
      fetch(`https://foodcorps.tfaforms.net/responses/processor`, {
        mode: 'no-cors',
        method: 'POST',
        body: this.formDataToUrlEncoded(tfaFormData),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      })
        .then((response) => response.text())
        .catch((error) => console.error('Error:', error));
      formData.append('_wpcf7_unit_tag', `wpcf7-${id}-123`);
      // Send the data as JSON
      fetch(`/wp-json/contact-form-7/v1/contact-forms/${id}/feedback`, {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.status === 'mail_sent') {
            console.log('Message sent successfully!');
          } else {
            console.log('Something went wrong.');
          }
        })
        .then(() => {
          window.location.replace(endpoint);
        })
        .catch((error) => console.error('Error:', error));
    });
  };

  checkInputs = (fields) => {
    let check = true;
    fields.forEach((field) => {
      const input = field.querySelector('input');
      const message = field.querySelector('.js-multiform-required');
      let emailMessage = false;
      if (input.type == 'email') {
        emailMessage = field.querySelector('.js-multiform-email-validate');
      }
      if (!input.value) {
        check = false;
        message.classList.add('active');
      } else if (input.type == 'email') {
        message.classList.remove('active');
        if (!this.validateEmail(input.value)) {
          check = false;
          emailMessage?.classList.add('active');
        } else {
          emailMessage?.classList.remove('active');
        }
      } else {
        message.classList.remove('active');
      }
    });
    return check;
  };
  validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };
}

export default MultistepForm;
new MultistepForm();
